import React, { useState, useEffect } from "react";
import { Box, Divider } from "@mui/material";
import { useSelector } from "react-redux";

// Import new components 
import Header from "../Components/Header/Header";
import SectionTitle2 from "../Components/Ui-Components/SectionTitle2/SectionTitle2";
import EventImageProcessor from "./EventImageProcessor";
import EventCertificateGenerator from "./EventCertificateGenerator";

const EventManager = ({ onClose, certificateData, onBackToSelection }) => {
  const [currentView, setCurrentView] = useState("imageProcessor");
  const [processedImages, setProcessedImages] = useState([]);
  const [processingIndex, setProcessingIndex] = useState(0);
  const state = useSelector((state) => state.shop.products);

  // Extract event fields from certificate data
  const [eventFields, setEventFields] = useState([]);

  useEffect(() => {
    if (certificateData && certificateData.eventFields) {
      // Initialize processed images array with null values
      const initialProcessedImages = certificateData.eventFields.map(() => null);
      setProcessedImages(initialProcessedImages);
      setEventFields(certificateData.eventFields);
    }
  }, [certificateData]);

  // Navigate to certificate generator after all images are processed
  const handleNavigateToCertificateGenerator = () => {
    setCurrentView("certificateGenerator");
  };

  // Navigate back to image processor
  const handleNavigateToImageProcessor = () => {
    setCurrentView("imageProcessor");
  };

  // Handle processed image from image processor
  const handleImageProcessed = (processedData, imageIndex) => {
    // console.log("🔄 Processing image at index:", imageIndex, "with data:", processedData);
    
    const newProcessedImages = [...processedImages];
    newProcessedImages[imageIndex] = {
      originalImage: eventFields[imageIndex].selectedImage,
      processedImageUrl: processedData.processedImageUrl || processedData,
      cropData: processedData.cropData || null,
      eventId: eventFields[imageIndex].eventId,
      bibNumber: eventFields[imageIndex].bibNumber,
      eventData: eventFields[imageIndex]
    };
    
    // console.log("✅ Updated processedImages:", newProcessedImages);
    setProcessedImages(newProcessedImages);

    // Check if all images are processed
    const allProcessed = newProcessedImages.every(img => img !== null);
    if (allProcessed) {
      // Auto-navigate to certificate generator when all images are done
      // handleNavigateToCertificateGenerator();
    }
  };

  // Handle single image reprocessing
  const handleReprocessImage = (imageIndex) => {
    setProcessingIndex(imageIndex);
    setCurrentView("imageProcessor");
  };

  // Check completion status
  const isProcessingComplete = processedImages.every(img => img !== null);
  const processedCount = processedImages.filter(img => img !== null).length;

  return (
    <Box sx={{ height: '100%' }}>
      {/* <Header /> */}
      {/* <SectionTitle2
        title={state.eventName || "ProCam Certificate Generator"}
        eventLogo={state.eventLogo}
        eventLogoShow={true}
        page={"procam-certificate"} 
      /> */}
      <Divider sx={{ margin: "0px 20px" }} />
      
      {currentView === "imageProcessor" ? (
        <EventImageProcessor
          eventFields={eventFields}
          processedImages={processedImages}
          processingIndex={processingIndex}
          onImageProcessed={handleImageProcessed}
          onNavigateToCertificate={handleNavigateToCertificateGenerator}
          onClose={onClose}
          templateDetails={certificateData.templateDetails}
          onBackToImageSelection={onBackToSelection}
        />
      ) : (
        <EventCertificateGenerator
          processedImages={processedImages}
          eventFields={eventFields}
          onNavigateToImageProcessor={handleNavigateToImageProcessor}
          onReprocessImage={handleReprocessImage}
          onClose={onClose}
        />
      )}
    </Box>
  );
};

export default EventManager;